<template id="Direcionamento">
    <v-ons-page id="DirecionamentoPage">
      <v-ons-row width="90%" style="align-itens:center">
        <v-ons-col>
          <img src="../assets/img/logo.png" width="200px" style="margin:20px; padding-top:20px">
          <h3  style="  font-size:20px;">Para resgatar vá até a<br> geladedira de heineken 0.0.</h3>
          <img src="../assets/img/geladeira.png" width="150px" style="margin:20px;">
          <v-ons-button class="botao" @click="openLeitorQrCode()">Ok</v-ons-button>
        </v-ons-col>
      </v-ons-row>
    </v-ons-page>
</template>
<style scoped>


</style>
<script>
import LeitorQrCodeVue from './LeitorQrCode.vue';

export default {
  name: 'Direcionamento',
  key: 'Direcionamento',
  data() {
    return {

    };
  },
   props: ['pageStack'],
  methods: {
    openLeitorQrCode(){ 
        this.$emit('push',LeitorQrCodeVue);
    }
  }
}
</script>